import { gsap, ScrollTrigger } from '@hh/gsap.js'
gsap.registerPlugin(ScrollTrigger)

const fetchData = (e) => {
  const value = e.detail.value?.params

  const url =
    `${window.location.pathname}?` +
    getSections()
      .map((section) => `sections[]=${section.section}`)
      .join('&') +
    `&${value}`

  fetch(url)
    .then((response) => response.json())
    .then((parsed) => {
      const html = Object.values(parsed).join('')
      rerenderElement('.js-orders-container', html)
      rerenderElement('.js-blogs-first-col', html)
      rerenderElement('.js-blogs-second-col', html)
    })
    .then(() => {
      ScrollTrigger.refresh()
    })
}

const rerenderElement = (className, html) => {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
  const data = parsedHTML.querySelector(className)?.innerHTML
  document.querySelector(className)?.insertAdjacentHTML('beforeend', data)
  renderCustomItem(parsedHTML, '.js-load-more')
}

const renderCustomItem = (html, selector) => {
  const inHtml = html.querySelector(selector)
  if (!inHtml) return
  document
    .querySelectorAll(selector)
    .forEach((element) => (element.innerHTML = inHtml.innerHTML))
}

const getSections = () => {
  return [
    {
      id: 'Orders',
      section: document.getElementById('Orders')?.dataset.id,
    },
    {
      id: 'BlogArticles',
      section: document.getElementById('BlogArticles')?.dataset.id,
    },
  ]
}

window.addEventListener('load-more-grid', fetchData)
